import usePhotoController from "@customer/api/usePhotoController"
import useActions from "./hooks/useActions"
import useApi from "./hooks/useApi"
import useMethods from "./hooks/useMethods"

export default function useGallery(): Customer.Models.Gallery {
    const controller = usePhotoController()
    const response = controller.index.use("customer:gallery")

    const api = useApi(response, controller)
    const methods = useMethods(response)
    const actions = useActions(response, api, methods)

    return { 
        state: response.data, 
        setState: response.setData, 
        fresh: response.fresh,
        methods,
        api,
        actions
    }
}